import MxTypography from "@rf-l1/MxTypography";

interface MxDetailCardAgentEmailProps {
  email: string;
}
const MxDetailCardAgentEmail = (props: MxDetailCardAgentEmailProps) => {
  return (
    <MxTypography
      color="grey.700"
      variant="caption"
      fontWeight={400}
      lineHeight={2}
      autoCopy
      removeAutoCopyStyles
    >
      {props.email}
    </MxTypography>
  );
};
export default MxDetailCardAgentEmail;
